import Vue from 'vue';
import Designer from './designer.vue';

const urlParams = new URLSearchParams(window.location.search);

new Vue({
  el: '#designer',
  render: function (createElement) {
    return createElement(Designer, {
      props: {
        isQuickCheckout: (urlParams.get('quickCheckout') || 0) == 1
      }
    })
  }
})
